// Styles propres au CRM — complètent COCKPIT_CSS, dont ils reprennent le scope
// `.ckpt` et les variables (--line, --surface, --violet…) pour que le CRM et le
// Cockpit restent visuellement indistinguables, thème clair comme sombre.
export const CRM_CSS = `
/* ── Barre de sélection de compte ── */
.ckpt .crm-accbar{display:flex;align-items:center;gap:10px;margin-bottom:16px;flex-wrap:wrap}
.ckpt .crm-accbar-lbl{font-size:.7rem;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.5px}
.ckpt .sp{flex:1}

/* ── Champs ── */
.ckpt .crm-select,.ckpt .crm-input{background:var(--surface);border:1px solid var(--line2);color:var(--text);
  border-radius:12px;padding:9px 12px;font-size:.84rem;font-family:inherit;outline:none;transition:.15s}
.ckpt .crm-select{cursor:pointer}
.ckpt .crm-select:focus,.ckpt .crm-input:focus{border-color:var(--violet)}
.ckpt .crm-select-sm{padding:5px 9px;font-size:.75rem;border-radius:9px}
.ckpt .crm-input::placeholder{color:var(--muted2)}
.ckpt .crm-input-inline{padding:4px 9px;font-size:.9rem;font-weight:700;min-width:210px}

.ckpt .crm-addrow{display:flex;gap:8px;margin-bottom:18px}
.ckpt .crm-addrow .crm-input{flex:1;max-width:380px}
.ckpt .crm-addrow-sub{margin:12px 0 0;padding-left:14px}

.ckpt .btn-sm{padding:5px 11px;font-size:.75rem;border-radius:9px}
.ckpt .btn-danger{color:var(--lose)}
.ckpt .btn-danger:hover{border-color:var(--lose);color:var(--lose)}

/* ── Entité ── */
.ckpt .crm-ent{background:var(--surface);border:1px solid var(--line);border-radius:var(--radius);
  padding:15px 17px;margin-bottom:14px;box-shadow:var(--shadow)}
.ckpt .crm-ent-h{display:flex;align-items:center;gap:9px;padding-bottom:11px;border-bottom:1px solid var(--line);flex-wrap:wrap}
.ckpt .crm-ent-ic{font-size:1rem}
.ckpt .crm-ent-name{background:none;border:none;font-family:inherit;cursor:pointer;
  font-size:.98rem;font-weight:800;color:var(--text);padding:2px 5px;border-radius:7px}
.ckpt .crm-ent-name:hover{background:var(--violet-soft)}
.ckpt .crm-ent-meta{font-size:.74rem;color:var(--muted)}

/* ── Équipe ── */
.ckpt .crm-team{padding:12px 0 12px 14px;border-bottom:1px solid var(--line)}
.ckpt .crm-team:last-of-type{border-bottom:none}
.ckpt .crm-team-h{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.ckpt .crm-team-name{background:none;border:none;font-family:inherit;cursor:pointer;
  font-size:.86rem;font-weight:700;color:var(--text);padding:2px 5px;border-radius:7px}
.ckpt .crm-team-name:hover{background:var(--violet-soft)}
.ckpt .crm-pill{font-size:.66rem;font-weight:800;padding:3px 10px;border-radius:20px;white-space:nowrap}
.ckpt .crm-team-empty{font-size:.75rem;color:var(--muted2);margin-top:9px;font-style:italic}

/* ── Fiches clients rattachées à une équipe ── */
.ckpt .crm-fiches{display:flex;flex-wrap:wrap;gap:7px;margin-top:10px}
.ckpt .crm-fiche-chip{display:inline-flex;align-items:center;gap:7px;cursor:pointer;font-family:inherit;
  background:var(--surface2);border:1px solid var(--line2);border-radius:20px;padding:4px 12px 4px 4px;transition:.15s}
.ckpt .crm-fiche-chip:hover{border-color:var(--violet)}
.ckpt .crm-av{width:23px;height:23px;border-radius:50%;background:var(--violet-soft2);color:var(--acc);
  display:inline-flex;align-items:center;justify-content:center;font-size:.6rem;font-weight:800;flex-shrink:0}
.ckpt .crm-fiche-nm{font-size:.79rem;font-weight:700;color:var(--text)}
.ckpt .crm-fiche-fn{font-size:.72rem;color:var(--muted)}
.ckpt .crm-deci{color:var(--a);font-size:.8rem}

/* KPI ambré — le Cockpit ne définit que .good (vert) et .alert (rouge). */
.ckpt .kpi .val.warn{color:var(--a)}

/* ── Fiche client ── */
.ckpt .crm-fiche-head{display:flex;align-items:center;gap:13px;margin-bottom:14px;flex-wrap:wrap}
.ckpt .crm-av-lg{width:44px;height:44px;font-size:.95rem}
.ckpt .crm-fiche-title{font-size:1.25rem;font-weight:800;letter-spacing:-.4px;display:flex;align-items:center;gap:7px}
.ckpt .crm-fiche-sub{font-size:.8rem;color:var(--muted);margin-top:2px}
.ckpt .crm-pill-ok{background:rgba(74,222,128,.14);color:var(--win)}
.ckpt .crm-pill-warn{background:rgba(250,204,21,.14);color:var(--a)}
.ckpt .crm-banner{background:var(--violet-soft);border:1px solid var(--violet-soft2);border-radius:14px;
  padding:11px 15px;font-size:.83rem;margin-bottom:16px}

.ckpt .crm-cols{display:grid;grid-template-columns:repeat(auto-fit,minmax(330px,1fr));gap:14px;margin-bottom:14px}
.ckpt .crm-card{padding:17px 19px;margin-bottom:0}
.ckpt .crm-card-t{font-size:.8rem;font-weight:800;color:var(--text);margin-bottom:12px}
.ckpt .crm-card-t2{margin-top:20px}

.ckpt .crm-grid2{display:grid;grid-template-columns:1fr 1fr;gap:11px}
.ckpt .crm-field{display:flex;flex-direction:column;gap:5px}
.ckpt .crm-field>span{font-size:.72rem;font-weight:700;color:var(--muted)}
.ckpt .crm-field-wide{grid-column:1/-1}
.ckpt .crm-check{flex-direction:row;align-items:center;gap:8px;align-self:end;padding-bottom:9px}
.ckpt .crm-check input{width:16px;height:16px;accent-color:var(--violet);cursor:pointer}
.ckpt .crm-check span{font-size:.8rem;font-weight:700;color:var(--text)}
.ckpt .crm-textarea{resize:vertical;line-height:1.5;font-size:.83rem}

.ckpt .crm-chipline{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:9px}
.ckpt .crm-tag{display:inline-flex;align-items:center;gap:6px;background:var(--violet-soft);color:var(--acc);
  border-radius:20px;padding:4px 6px 4px 12px;font-size:.75rem;font-weight:700}
.ckpt .crm-tag button{background:none;border:none;color:inherit;cursor:pointer;font-size:.7rem;opacity:.7;padding:0 3px}
.ckpt .crm-tag button:hover{opacity:1}

/* ── Journal des actions ── */
.ckpt .crm-logrow{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px}
.ckpt .crm-log-note{flex:1;min-width:170px}
.ckpt .crm-timeline{display:flex;flex-direction:column}
.ckpt .crm-tl-row{display:flex;align-items:center;gap:11px;padding:9px 0;border-bottom:1px solid var(--line);flex-wrap:wrap}
.ckpt .crm-tl-row:last-child{border-bottom:none}
.ckpt .crm-tl-type{font-size:.7rem;font-weight:800;background:var(--violet-soft);color:var(--acc);
  border-radius:20px;padding:3px 11px;min-width:58px;text-align:center}
.ckpt .crm-tl-date{font-size:.76rem;color:var(--muted);font-variant-numeric:tabular-nums}
.ckpt .crm-tl-note{font-size:.82rem;color:var(--text)}

.ckpt .crm-footbar{display:flex;align-items:center;gap:9px;margin-top:16px;flex-wrap:wrap}

/* ── État vide (reprend .ckpt-empty, avec un bouton dessous) ── */
.ckpt .crm-empty-actions{margin-top:16px;display:flex;gap:9px;justify-content:center;flex-wrap:wrap}

/* ── Comptes clients ── */
.ckpt .crm-searchbar{display:flex;align-items:center;gap:9px;margin-bottom:16px;flex-wrap:wrap}
.ckpt .crm-searchbar .crm-input{flex:1;min-width:200px}
.ckpt .crm-create{margin-bottom:18px}
.ckpt .crm-open{color:var(--acc);font-weight:800}

/* ── Reporting : lignes de relance cliquables ── */
.ckpt .crm-rl{display:flex;flex-direction:column}
.ckpt .crm-rl-row{display:flex;align-items:center;gap:11px;width:100%;text-align:left;font-family:inherit;
  background:none;border:none;border-bottom:1px solid var(--line);padding:10px 8px;border-radius:10px;cursor:pointer;transition:.12s}
.ckpt .crm-rl-row:last-child{border-bottom:none}
.ckpt .crm-rl-row:hover{background:var(--violet-soft)}
.ckpt .crm-rl-id{display:flex;flex-direction:column;min-width:0}
.ckpt .crm-rl-nm{font-size:.85rem;font-weight:700;color:var(--text)}
.ckpt .crm-rl-sub{font-size:.73rem;color:var(--muted);margin-top:1px}

/* ── Reporting : histogrammes horizontaux ── */
.ckpt .crm-bars{display:flex;flex-direction:column;gap:10px}
.ckpt .crm-bar{display:grid;grid-template-columns:130px 1fr 40px;align-items:center;gap:12px}
.ckpt .crm-bar-k{font-size:.79rem;font-weight:700;color:var(--text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ckpt .crm-bar-t{height:11px;border-radius:20px;background:var(--surface2);border:1px solid var(--line);overflow:hidden}
.ckpt .crm-bar-f{display:block;height:100%;border-radius:20px;background:var(--violet);transition:.2s}
.ckpt .crm-bar-v{font-size:.79rem;font-weight:800;color:var(--muted);text-align:right;font-variant-numeric:tabular-nums}
@media(max-width:600px){.ckpt .crm-bar{grid-template-columns:96px 1fr 34px;gap:9px}}
`;
